import { createSlice } from "@reduxjs/toolkit";
import {PURGE} from "redux-persist";

const initialState = {
  isOverlayPanelActive: false,
  overlayPanelItem: ""
}

const overlayPanelSlice = createSlice({
  name : "overlayPanel",
  initialState : initialState,
  reducers : {
    setIsOverlayPanelActive (state, action) {
      state.isOverlayPanelActive = action.payload;
    },
    setOverlayPanelItem (state, action) {

      state.overlayPanelItem = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  }
})


export default overlayPanelSlice
